import React from "react";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import { useStrapiConfig } from "hooks/useStrapiConfig";
import { getLogoUrl } from "theme";
import { SxProps, Theme } from "@mui/material/styles";
import Header from "./Header";
import Main from "./Main";
import Footer from "./Footer";

const PAGE_SX: SxProps<Theme> = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
  color: "text.primary",
};

// Generic shell for every route: background, Header, Main (wrapping the routed
// page via Outlet), and Footer. Carries no per-route configuration — any page
// that needs something different handles it in its own content, or via props
// passed directly to Header/Main/Footer where those are used directly.
const Layout = (): JSX.Element => {
  const { data: loginPageConfig } = useStrapiConfig();
  const logoUrl = getLogoUrl(loginPageConfig?.login_page_style);

  return (
    <Box sx={PAGE_SX}>
      <Header logoSrc={logoUrl ?? undefined} />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </Box>
  );
};

export default Layout;
